import { env } from 'src/helpers'

export const initPayReadyAuth = () => {
  const base_url = env('payready_base_url') as string
  const client_id = env('payready_client_id') as string
  const redirect_uri = env('payready_redirect_uri') as string

  const responseType = 'code'
  // Recovery's /me.json returns the full buzz_doorkeeper_json (company, properties, role)
  // only when the token carries `buzz`; otherwise it returns an id/email/name stub.
  const scope = encodeURIComponent('user buzz')
  const url = `${base_url}/oauth/authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=${responseType}&scope=${scope}`

  window.location.href = url
}

export const handlePayReadyAuthCallback = async (code: string) => {
  const redirect_uri = env('payready_redirect_uri') as string
  const exchangeTokenUrl = `${env('rest_api_endpoint')}/auth/exchange`

  const response = await fetch(exchangeTokenUrl, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      code,
      redirect_uri,
    }),
    signal: AbortSignal.timeout(5000),
  })
  const data = await response.json()

  if (!data?.success) throw new Error('Failed to exchange token')
}

export const signOutFromPayReady = () => {
  window.location.href = `${env('payready_base_url')}/sign_out`
}

export const validatePayReadyUserToken = async () => {
  const response = await fetch(`${env('rest_api_endpoint')}/auth/me`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-payready-flow': 'true',
    },
    signal: AbortSignal.timeout(5000),
  })
  const data = await response.json()

  return data
}
